module.exports = __webpack_public_path__ + "media/react/marketing/pages/home/ielts/sections/apps/assets/prep_app-4ea02e65cf50cd63ee1ff09d596d253a.png";